import { render, staticRenderFns } from "./chat-images.vue?vue&type=template&id=25534399&scoped=true&"
import script from "./chat-images.vue?vue&type=script&lang=js&"
export * from "./chat-images.vue?vue&type=script&lang=js&"
import style0 from "./chat-images.vue?vue&type=style&index=0&id=25534399&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25534399",
  null
  
)

export default component.exports